import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, FormHelperText, Grid, Stack } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import Helpers from "../../helpers/helpers";
// import PlateNoDetectionHelper from "../../helpers/plate_no_detection_helper";
import { getGeneral, getInventoryDetails, resetInventoryActionState, resetInventoryState, updateInventory, getInventoryStockStatuses } from "../../store/actions";
import "../Advert/advert.css";
import Label from "../../components/Common/Label";

const EditInventory = ({ leftSideBarType, layoutWidth, makeList, modelList, bodyList, license_categories, inventoryDetails,
  inventoryEdit, inventoryUpdateError, isDirectSeller, userData, generalCommonCode, inventoryDetailsInd, defaultColorList, inventoryStockStatuses }) => {
  const isSingPass = Boolean(inventoryDetails?.myinfo_make || inventoryDetails?.myinfo_model);
  const isPublished = inventoryDetails?.status === "published";
  const isDirectPublished = isDirectSeller && isPublished && !isSingPass;
  const isDirectSingPassPublished = isDirectSeller && isPublished && isSingPass;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ID } = useParams();
  const [formObj, setFormObj] = useState({});
  const [preSelectBodyType, setPreSelectBodyType] = useState([]);
  const previousModelIdRef = useRef(undefined);
  const [loading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [error, setError] = useState({});


  useEffect(() => {
    if (isDirectSeller)
      navigate("/not-found")
  }, [])

  useEffect(() => {
    dispatch(resetInventoryState());
    dispatch(getGeneral());
    dispatch(getInventoryStockStatuses());
  }, [])

  useEffect(() => {
    if (inventoryDetails?.id) {
      const inventoryType = inventoryDetails?.inventory_type?.toLowerCase() || null;
      const inventoryForm = {
        inventory_type: inventoryType,
        reg_no: inventoryDetails?.register_number ?? null,
        revision: inventoryDetails?.revision ?? null,
        make_id: inventoryDetails?.bike_make_id ?? null,
        model_id: inventoryDetails?.bike_model_id ?? null,
        manu_year: inventoryDetails?.manu_year ?? null,
        license_categories: inventoryDetails?.license_category_id ?? null,
        model_colour_id: inventoryDetails?.bike_model_colour_id ?? null,
        colour_text: inventoryDetails?.colour_text ?? inventoryDetails?.color ?? null,
        stock_status: inventoryDetails?.stock_status ?? null,
        body_type: inventoryDetails?.body_types || [],
        engine_cap: inventoryDetails?.engine_cc ?? null,
        reg_date: inventoryDetails?.registration_date ?? null,
        coe_expiry: inventoryDetails?.coe_expiry ? moment(inventoryDetails.coe_expiry).format('YYYY-MM-DD') : null,
        mileage: inventoryDetails?.mileage_in_km ?? null,
        no_of_owner: inventoryDetails?.no_of_previous_owners ?? null,
        // stock_status: selectedStockStatus?.value ?? inventoryDetails?.stock_status ?? null,
        owner_name: inventoryDetails?.owner_name ?? null,
        email: inventoryDetails?.owner_email ?? null,
        phone: inventoryDetails?.owner_phone ? String(inventoryDetails.owner_phone).replace(/^\+?65/, '') : null,
        purchase_price: inventoryDetails?.purchase_price ?? null,
        arf: inventoryDetails?.arf ?? null,
        suggested_price: inventoryDetails?.suggested_price ?? null,
        internal_remarks: inventoryDetails?.internal_remarks ?? null,
      };

      if (inventoryType === 'rental') {
        Object.assign(inventoryForm, {
          daily_rate: inventoryDetails?.rental_rates?.daily_rate ?? null,
          weekend_rate: inventoryDetails?.rental_rates?.weekend_rate ?? null,
          three_day_rate: inventoryDetails?.rental_rates?.['3_days_rate'] ?? null,
          weekly_rate: inventoryDetails?.rental_rates?.weekly_rate ?? null,
          monthly_rate: inventoryDetails?.rental_rates?.monthly_rate ?? null,
        });
      }

      setFormObj(inventoryForm);
      setIsLoading(false);
    }
  }, [inventoryDetails, inventoryStockStatuses])

  useEffect(() => {
    if (inventoryDetailsInd?.code && inventoryDetailsInd?.code !== 'success') {
      setIsLoading(false);
    }
  }, [inventoryDetailsInd]);


  useEffect(() => {
    if (inventoryEdit?.code === 'success') {
      setNotification({ open: true, msg: inventoryEdit?.message || 'Inventory updated successfully', type: 'success' });
      setIsLoading(false);
      error && setError({});
      dispatch(resetInventoryActionState());
      navigate(`/inventory`);
    } else if (inventoryEdit?.code === "invalid_field" || inventoryEdit?.code === "error") {
      setError(inventoryEdit?.errors);
      setNotification({ open: true, msg: inventoryEdit?.message || 'Invalid fields', type: 'error' });
      setIsLoading(false);
      dispatch(resetInventoryActionState());
    }
  }, [inventoryEdit])

  useEffect(() => {
    if (!inventoryUpdateError || (Array.isArray(inventoryUpdateError) && inventoryUpdateError.length === 0)) return;
    setIsLoading(false);
    setNotification({
      open: true,
      msg: inventoryUpdateError?.message || inventoryUpdateError?.[0] || "Unable to update inventory.",
      type: "error",
    });
    dispatch(resetInventoryActionState());
  }, [inventoryUpdateError]);

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      dispatch(getInventoryDetails({ id: ID }));
    }
  }, [ID])

  const handlePreselectBikeTypes = (init) => {
    const body_list = filterModelList?.find((item => item?.id == formObj?.model_id)) || [];
    const body_list_ids = body_list?.bike_types?.map((x) => x.bike_type_id) || [];
    const selectedModel = filterModelList?.length > 0 && filterModelList.find(
      (model) => String(model.id) === String(formObj?.model_id)
    );
    if (selectedModel) {
      // Set license_category_id from the selected model
      // handleFormChange('license_category_id', selectedModel.license_category || "");
      // handleFormChange('transmission', selectedModel.transmission || "");
      // handleFormChange('engine_cap', selectedModel.engine_cc || "");
      // handleFormChange('body_type', body_list_ids || []);
      setPreSelectBodyType(body_list_ids || []);
      // if (formObj?.model_id != selectedModel?.id) {
      !init && setFormObj(prev => ({ ...prev, body_type: body_list_ids || [] }));

      // }
      return true;
    }
    return false;
  }

  useEffect(() => {
    // only treat it as a real model change (and reset body_type) when model_id itself changed, not when makeList/modelList got a new reference
    const modelChanged = previousModelIdRef.current !== undefined && String(previousModelIdRef.current) !== String(formObj?.model_id);
    handlePreselectBikeTypes(!modelChanged);
    previousModelIdRef.current = formObj?.model_id;
  }, [formObj?.model_id, makeList, modelList])

  const filterModelList = formObj?.make_id ? makeList.find((make) => make.id === formObj?.make_id)?.models : modelList;
  const filterColorList = filterModelList?.find((item => item?.id === formObj?.model_id))?.colours || [];
  const filterBodyList = filterModelList?.bike_types || bodyList;

  const handleFormObjChange = (key, value) => {
    setFormObj(prev => ({ ...prev, [key]: value }));
  }

  const handleSelectBodyType = (item) => {
    const bodyTypeId = item?.id || item?.bike_type_id;
    if (preSelectBodyType?.some((id) => String(id) === String(bodyTypeId))) {
      return
    } else {
      let updatedBodyType = formObj?.body_type ? [...formObj?.body_type] : [];
      if (updatedBodyType.some((id) => String(id) === String(bodyTypeId))) {
        updatedBodyType = updatedBodyType.filter((type) => String(type) !== String(bodyTypeId));
      } else {
        updatedBodyType.push(bodyTypeId);
      }
      handleFormObjChange('body_type', updatedBodyType);
    }

  }

  const handleSubmit = () => {
    setIsLoading(true);
    // Filter out any body_type ids that do not exist in the current filterBodyList
    const validIds = Array.isArray(filterBodyList) ? new Set(filterBodyList.map(b => String(b?.bike_type_id ?? b?.id))) : new Set();
    const bodyTypes = Array.isArray(formObj?.body_type) ? formObj.body_type.filter(id => validIds.has(String(id))) : [];
    const payload = {
      id: inventoryDetails?.id,
      data: {
        bike_make_id: formObj?.make_id,
        bike_model_id: formObj?.model_id,
        register_number: formObj?.register_number,
        revision: 0,
        // stock_status: formObj?.stock_status,
        manu_year: formObj?.manu_year || null,
        license_category_id: formObj?.license_categories,
        body_types: bodyTypes,
        bike_model_colour_id: formObj?.model_colour_id,
        colour_text: formObj?.colour_text,
        engine_cc: formObj?.engine_cap ? Number(formObj.engine_cap) : null,
        registration_date: formObj?.reg_date ? moment(formObj.reg_date).format('YYYY-MM-DD') : null,
        coe_expiry: formObj?.coe_expiry ? moment(formObj.coe_expiry).format('YYYY-MM-DD') : null,
        mileage_in_km: formObj?.mileage,
        no_of_previous_owners: formObj?.no_of_owner,
        owner_name: formObj?.owner_name,
        owner_email: formObj?.email,
        owner_phone: 65 + formObj?.phone,
        purchase_price: formObj?.purchase_price,
        suggested_price: formObj?.suggested_price,
        arf: formObj?.arf,
        internal_remarks: formObj?.internal_remarks,
      }
    };

    if (formObj?.inventory_type === 'rental') {
      payload.data.daily_rate = formObj?.daily_rate;
      payload.data['3_days_rate'] = formObj?.three_day_rate;
      payload.data.weekend_rate = formObj?.weekend_rate;
      payload.data.weekly_rate = formObj?.weekly_rate;
      payload.data.monthly_rate = formObj?.monthly_rate;
    }

    dispatch(updateInventory(payload));
  }

  const ownerDetails = () => {
    return (
      <div id="owner-details-section">
        <Box>
          {inventoryDetails?.inventory_type?.toLowerCase() === "used" &&
            <>
              <div className="text-semibold">Owner Details</div>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12}>
                  <CustomTextField
                    title={'Owner Name'}
                    values={formObj?.owner_name || ''}
                    onChange={(e) => handleFormObjChange('owner_name', e)}
                    error={error?.owner_name}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomTextField
                    title={'Email Address'}
                    values={formObj?.email || ''}
                    onChange={(e) => handleFormObjChange('email', e)}
                    error={error?.email}

                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomTextField
                    values={formObj?.phone}
                    onChange={(e) => handleFormObjChange('phone', e)}
                    title='Phone Number'
                    placeholder='Phone Number'
                    type={'phone'}
                    InputProps={{
                      startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                    }}
                    error={error?.owner_phone}
                  />
                </Grid>
              </Grid>
            </>
          }
        </Box>
      </div>
    )
  }

  const vehicleInfoForm = () => {
    return (
      <div id="vehicle-info-section">
        <Box>
          <div className="text-semibold">Make & Model</div>
          <Grid container spacing={2}>
            {isSingPass &&
              <>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomTextField
                    title={'Make (Myinfo) '}
                    disabled={true}
                    values={inventoryDetails?.myinfo_make || ''}

                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomTextField
                    title={'Model (Myinfo) '}
                    values={inventoryDetails?.myinfo_model || ''}
                    disabled={true}
                  />
                </Grid>
              </>}
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <CustomSelect
                title={'Make'}
                placeholder={'Make'}
                disabled={isDirectPublished || isSingPass || isDirectSingPassPublished}
                values={formObj?.make_id || ''}
                onChange={(e) => { handleFormObjChange('make_id', e); setPreSelectBodyType([]); handleFormObjChange('model_id', ''); handleFormObjChange('model_colour_id', ''); handleFormObjChange('body_type', ''); }}
                data={makeList || []}
                labelName={'name'}
                valueName={'id'}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <CustomSelect
                title={'Model'}
                placeholder={'Model'}
                values={formObj?.model_id || ''}
                onChange={(e) => { handleFormObjChange('model_id', e); }}
                data={filterModelList || []}
                labelName={'name'}
                disabled={isDirectPublished || isDirectSingPassPublished}
                valueName={'id'}
              />
            </Grid>

            {inventoryDetails?.inventory_type?.toLowerCase() !== "new" &&
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <CustomTextField
                  title={'Registration Number'}
                  values={formObj?.reg_no || ''}
                  disabled={isSingPass}
                  isOptional={true}
                  onChange={(e) => handleFormObjChange('reg_no', e)}
                  error={error?.reg_no}
                />
              </Grid>}
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <CustomTextField
                title={'Year of manufacture'}
                placeholder={'Year of manufacture'}
                values={formObj?.manu_year || ''}
                isOptional={true}
                disabled={isSingPass || isDirectSingPassPublished}
                onChange={(e) => handleFormObjChange('manu_year', e)}
                error={error?.manu_year}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <CustomSelect
                title={'License Category'}
                placeholder={'License Category'}
                values={formObj?.license_categories || ''}
                onChange={(e) => handleFormObjChange('license_categories', e)}
                data={license_categories || []}
                labelName={'name'}
                valueName={'id'}
                error={error?.license_category_id}
                disabled={isDirectSingPassPublished}
              />
            </Grid>
          </Grid>
        </Box>
        {inventoryDetails?.inventory_type?.toLowerCase() !== "used" &&
          <Box mt={4}>
            <div className="text-semibold">Primary Colour <span className="optional-label me-2">Optional</span></div>
            <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
              {filterColorList?.length > 0 ? filterColorList?.map((color, index) => (
                <div className={formObj?.model_colour_id === color.id ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormObjChange('model_colour_id', formObj?.model_colour_id === color.id ? null : color.id); handleFormObjChange('colour_text', null); }}>
                  {color.name}
                </div>
              )) || <div className="subheader-2">No Data Available</div> : defaultColorList?.length > 0 && (defaultColorList.map((color, index) => (
                <div className={formObj?.colour_text && (formObj?.colour_text === color?.value) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormObjChange('colour_text', formObj?.colour_text === color?.value ? null : color?.value); handleFormObjChange('model_colour_id', null); }}>
                  {color?.label}
                </div>
              ))) || <div className="subheader-2">No Data Available</div>
              }
            </Stack>

          </Box>}
        <Box mt={4}>
          <div className="text-semibold">Body Type</div>
          <div className="subheader-2">Select one or more</div>
          <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
            {filterBodyList?.length > 0 ? filterBodyList?.map((item, index) => (
              <div className={preSelectBodyType?.some((id) => String(id) === String(item?.id || item?.bike_type_id)) ? "default-selected" : formObj?.body_type?.some((id) => String(id) === String(item?.id || item?.bike_type_id)) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleSelectBodyType(item)}>
                {item?.name}
              </div>
            )) : <div className="subheader-2">No Data Available</div>}
          </Stack>
          {error?.body_types && <FormHelperText error={!!error?.body_types} sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.body_types}</FormHelperText>}
        </Box>
        <Box mt={4}>
          <div className="text-semibold">Specification</div>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <CustomTextField
                title={'Engine Capacity (CC)'}
                placeholder={'Engine Capacity (CC)'}
                values={formObj?.engine_cap}
                type={'number'}
                onChange={(e) => handleFormObjChange('engine_cap', e)}
                error={error?.engine_cc}
              />
            </Grid>
            {
              inventoryDetails?.inventory_type === "used" && <>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomizedDatePicker
                    title={"Registration Date"}
                    values={(formObj?.reg_date || formObj?.first_reg_date) && new Date(formObj?.reg_date || formObj?.first_reg_date)}
                    placeholder={"dd/mm/yyyy"}
                    disabled={isSingPass}
                    setFormValues={(e) => handleFormObjChange('reg_date', e)}
                    error={error?.reg_date || error?.registration_date}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomizedDatePicker
                    title={"COE Expiry Date"}
                    values={formObj?.coe_expiry && new Date(formObj?.coe_expiry)}
                    placeholder={"dd/mm/yyyy"}
                    disabled={isSingPass}
                    setFormValues={(e) => handleFormObjChange('coe_expiry', e)}
                    error={error?.coe_expiry}
                  />
                </Grid>
              </>
            }

            {inventoryDetails?.inventory_type?.toLowerCase() !== "new" &&
              <>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomTextField
                    title={<>Mileage (KM)</>}
                    placeholder={'Mileage (KM)'}
                    type={'number'}
                    isOptional={true}
                    values={formObj?.mileage ?? ""}
                    onChange={(e) => handleFormObjChange('mileage', e)}
                    error={error?.mileage_in_km}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <CustomTextField
                    title={'No. of Owner(s)'}
                    placeholder={'No. of Owner(s)'}
                    type={'number'}
                    disabled={isSingPass}
                    values={formObj?.no_of_owner ?? ""}
                    onChange={(e) => handleFormObjChange('no_of_owner', e)}
                    error={error?.no_of_previous_owners}
                  />
                </Grid>
              </>}
          </Grid>
        </Box>
        <Box mt={4}>
          <div className="text-semibold">Stock Status</div>
          <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
            <div className={"vehicle-small-button-selected"} >
              {formObj?.stock_status}
            </div>
          </Stack>
          {error?.stock_status && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.stock_status || ""}</FormHelperText>}
        </Box>
      </div >
    )
  }

  const pricingInfo = () => {
    return (
      <div id="pricing-info-section">
        {
          formObj?.inventory_type === 'rental' ?
            <Box mt={4}>
              <div className="text-semibold mb-2">Rental Rate</div>
              <div className="subheader-2 mb-2">Please enter at least one rental rate (daily, 3-day, weekly, or monthly) before continuing.</div>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <CustomTextField
                    title={'Daily rate'}
                    placeholder={'Daily rate'}
                    values={formObj?.daily_rate}
                    onChange={(e) => handleFormObjChange('daily_rate', e)}
                    InputProps={{ startAdornment: '$' }}
                    error={error?.daily_rate}
                  // disabled={isDirectSingPassPublished}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <CustomTextField
                    title={'Weekend rate'}
                    placeholder={'Weekend rate'}
                    values={formObj?.weekend_rate}
                    onChange={(e) => handleFormObjChange('weekend_rate', e)}
                    InputProps={{ startAdornment: '$' }}
                    error={error?.weekend_rate}
                  // disabled={isDirectSingPassPublished}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <CustomTextField
                    title={'3-day rate'}
                    placeholder={'3-day rate'}
                    values={formObj?.three_day_rate}
                    onChange={(e) => handleFormObjChange('three_day_rate', e)}
                    InputProps={{ startAdornment: '$' }}
                    // disabled={isDirectSingPassPublished}
                    error={error?.['3_days_rate'] || error?.['three_day_rate']}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <CustomTextField
                    title={'Weekly rate'}
                    placeholder={'Weekly rate'}
                    values={formObj?.weekly_rate}
                    onChange={(e) => handleFormObjChange('weekly_rate', e)}
                    InputProps={{ startAdornment: '$' }}
                    error={error?.weekly_rate}
                  // disabled={isDirectSingPassPublished}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <CustomTextField
                    title={'Monthly rate'}
                    placeholder={'Monthly rate'}
                    values={formObj?.monthly_rate}
                    onChange={(e) => handleFormObjChange('monthly_rate', e)}
                    InputProps={{ startAdornment: '$' }}
                    error={error?.monthly_rate}
                  // disabled={isDirectSingPassPublished}
                  />
                </Grid>
              </Grid>
            </Box>
            :
            <>
              {
                <>
                  <Box mt={4}>
                    <div className="text-semibold">Pricing</div>
                    <Grid container spacing={2}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                          title={'Purchase price'}
                          placeholder={'Purchase price'}
                          values={formObj?.purchase_price}
                          onChange={(e) => handleFormObjChange('purchase_price', e)}
                          InputProps={{ startAdornment: '$' }}
                          error={error?.purchase_price}
                        />
                      </Grid>
                      {inventoryDetails?.inventory_type?.toLowerCase() !== "used" &&
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <CustomTextField
                            title={'ARF'}
                            placeholder={'ARF'}
                            values={formObj?.arf}
                            onChange={(e) => handleFormObjChange('arf', e)}
                            InputProps={{ startAdornment: '$' }}
                            error={error?.arf}
                          />
                        </Grid>}

                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                          title={'Suggested Price'}
                          placeholder={'Suggested Price'}
                          type={'number'}
                          is2dp={true}
                          values={formObj?.suggested_price}
                          onChange={(e) => handleFormObjChange('suggested_price', e)}
                          InputProps={{ startAdornment: '$' }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </>
              }
            </>
        }
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ marginTop: layoutWidth <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
        <LoadingDialog open={loading || generalCommonCode?.code !== "success"} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} errors={error} />
          {inventoryDetailsInd?.code && inventoryDetailsInd?.code !== "success" ?
            <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
              <div className="text-center">
                <div className="header-2 pb-3">{inventoryDetailsInd?.message || "Something went wrong."}</div>
                <CustomButton
                  title={'Go to Inventory'}
                  press={() => navigate('/inventory')}
                  padding={20}
                />
              </div>
            </div> :
            <>
              <Grid container spacing={{ xs: 0.5, sm: 2 }} px={1} pt={{ xs: 0.5, sm: 2 }} style={{ position: 'fixed', backgroundColor: 'white', zIndex: 9, marginTop: -25, width: '100%' }}>
                <Grid item sm={12}>
                  <CustomButton
                    title={
                      <div className="d-flex align-items-center" style={{ fontWeight: 400 }}>
                        <Icon icon={'fluent:chevron-left-20-regular'} style={{ marginRight: 10 }} />Back
                      </div>
                    }
                    borderRadius={"5px"}
                    borderStyle={"0px"}
                    backgroundColor={"transparent"}
                    textColor={"#000000"}
                    paddingInline={7}
                    press={() => navigate(`/inventory`)}
                  />
                </Grid>
                <Grid item xs={12} pr={0} mr={0}>
                  <div className="px-2">
                    <div className="header d-flex" style={{ flexWrap: 'wrap', wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                      {inventoryDetails?.vehicle || '-'}
                    </div>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 1,
                        mb: 1,
                      }}
                    >
                      {inventoryDetails?.stock_status && (
                        <Label.GeneralStatusLabel
                          label={Helpers?.normaliseStatus(inventoryDetails.stock_status)}
                          list={Helpers?.statusLabels}
                          marginLeft="0"
                        />
                      )}
                      {inventoryDetails?.manu_year && (
                        <>
                          {inventoryDetails?.stock_status && <span className="subheader-2">•</span>}
                          <span className="subheader-2">{inventoryDetails.manu_year}</span>
                        </>
                      )}
                      {inventoryDetails?.inventory_type && (
                        <>
                          {(inventoryDetails?.stock_status || inventoryDetails?.manu_year) && <span className="subheader-2">•</span>}
                          <span style={{ color: inventoryDetails.inventory_type.toLowerCase() === "new" ? "#2777C8" : "#FF7900" }}>
                            {inventoryDetails.inventory_type.toLowerCase() === "new"
                              ? "New"
                              : inventoryDetails.inventory_type.toLowerCase() === "rental"
                                ? "Rental"
                                : "Used"}
                          </span>
                        </>
                      )}
                      {inventoryDetails?.body_type && (
                        <>
                          {(inventoryDetails?.stock_status || inventoryDetails?.manu_year || inventoryDetails?.inventory_type) && <span className="subheader-2">•</span>}
                          <span className="subheader-2">{inventoryDetails.body_type}</span>
                        </>
                      )}
                      {inventoryDetails?.engine_cc && (
                        <>
                          {(inventoryDetails?.stock_status || inventoryDetails?.manu_year || inventoryDetails?.inventory_type || inventoryDetails?.body_type) && <span className="subheader-2">•</span>}
                          <span className="subheader-2">{inventoryDetails.engine_cc}cc</span>
                        </>
                      )}
                    </Box>
                  </div>
                </Grid>
              </Grid>
              <div id="content-container" style={{ paddingTop: layoutWidth <= 768 ? 90 : 150 }}>
                <Grid container spacing={2} px={3} pb={5}>
                  <Grid item xs={12}>
                    {ownerDetails()}
                  </Grid>
                  <Grid item xs={12}>
                    {vehicleInfoForm()}
                  </Grid>
                  <Grid item xs={12}>
                    {pricingInfo()}
                  </Grid>
                  <Grid item xs={12}>
                    <div className="mt-4">
                      <div className="text-semibold">Internal Remarks</div>
                      <CustomTextField
                        multiline={true}
                        rows={5}
                        values={formObj?.internal_remarks ?? ""}
                        onChange={(e) => handleFormObjChange('internal_remarks', e)}
                        error={error?.internal_remarks}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </>}

        </Container>
      </div>
      {inventoryDetailsInd?.code && inventoryDetailsInd?.code !== "success" ? <></> :
        <div className="mobile-button-container d-flex justify-content-between">
          <CustomButton
            title={'Cancel'}
            press={() => navigate(`/inventory`)}
            padding={20}
            backgroundColor={'#FFFFFF'}
            textColor={'#1D1B1B'}
            borderStyle={'1px solid #1D1B1B'}
          />
          <CustomButton
            title={'Save Changes'}
            press={() => handleSubmit()}
            padding={20}
          />
        </div>
      }

    </React.Fragment >
  );
};

function mapStateToProps({ Login, Layout, Inventory, General }) {
  const currentStateId = Login?.verifyAdmin?.user?.data?.profile?.state_id;
  const filteredBranchList = General?.states?.find((state) => state.id === currentStateId)?.cities || [];
  return {
    isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
    userData: Login?.verifyAdmin?.user?.data,
    userPermission: Login?.permissionArry,
    leftSideBarType: Layout.leftSideBarType,
    layoutWidth: Layout.currentWidth,
    inventoryDetails: Inventory.inventoryDetails?.data,
    inventoryDetailsInd: Inventory.inventoryDetails,
    makeList: General.bike_makes,
    modelList: General.bike_models,
    bodyList: General.bike_types,
    license_categories: General.license_categories,
    inventoryEdit: Inventory.inventoryEdit,
    inventoryUpdateError: Inventory.error,
    taggings: General.taggings,

    inventoryStockStatuses: Inventory?.inventoryStockStatuses?.library,
    generalCommonCode: General?.generalCommonCode,
    defaultColorList: General?.default_colours,

  };
}


export default connect(mapStateToProps)(EditInventory);
